import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { ListingContractType } from './types/Listing';
import { RentalConditions } from './types/RentalConditions';

type RentalConditionsEstimateSource =
  | {
      listingId: number;
    }
  | {
      listingUuid: string;
    }
  | {
      conversationId: number;
    }
  | {
      conversationUuid: string;
    };

export interface RentalConditionsEstimateParameters {
  startDate: string;
  endDate: string;
  pricingType?: string;
  contractType?: ListingContractType;
}

export default (makeCall: MakeCall) => (
  source: RentalConditionsEstimateSource,
  parameters: RentalConditionsEstimateParameters,
) =>
  makeCall<RentalConditions>(
    'POST',
    `${APIV2_URL}/bookings/rental-conditions/estimate`,
    {
      data: {
        source,
        ...parameters,
      },
    },
  );
